class AstPerfectMatch extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".ast-pm__slider");
    this.prevBtn = this.querySelector(".ast-pm__nav-btn--prev");
    this.nextBtn = this.querySelector(".ast-pm__nav-btn--next");
    this.cards = this.querySelectorAll(".ast-pm__card");

    if (this.cards.length > 0) {
      this.initSlider();
      this.initForms();
    }
  }

  initSlider() {

    this.prevBtn.addEventListener("click", () => this.scroll(-1));
    this.nextBtn.addEventListener("click", () => this.scroll(1));
    this.slider.addEventListener("scroll", () => this.updateNav());
    this.updateNav();
  }

  scroll(direction) {
    const cardWidth = this.cards[0].offsetWidth + 16; // card width + gap
    this.slider.scrollBy({ left: direction * cardWidth, behavior: "smooth" });
  }

  updateNav() {
    const cardWidth = this.cards[0].offsetWidth + 16;
    const index = Math.round(this.slider.scrollLeft / cardWidth) + 1;

    // Updates arrow disabled states
    this.prevBtn.disabled = index === 1;
    this.nextBtn.disabled = index === this.cards.length;
  }

  initForms() {
    const forms = this.querySelectorAll(".ast-pm__form");

    forms.forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const btn = form.querySelector(".ast-pm__add-btn");
        const originalText = btn.textContent;

        btn.textContent = "...";
        btn.classList.add("loading");

        const formData = new FormData(form);

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then(() => {
            btn.textContent = "Added";
            setTimeout(() => {
              btn.textContent = originalText;
              btn.classList.remove("loading");
            }, 2000);

            document.documentElement.dispatchEvent(
              new CustomEvent("cart:updated", { bubbles: true }),
            );
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) cartDrawer.classList.add("active");
          })
          .catch(() => {
            btn.textContent = "Error";
            btn.classList.remove("loading");
          });
      });
    });
  }
}

if (!customElements.get("ast-perfect-match")) {
  customElements.define("ast-perfect-match", AstPerfectMatch);
}
